// ✅ Correct if needed inside a component (not recommended for global.css though)
import './styles/global.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
function App() {
  return (
    <>
      <Header />
      <Hero />
      <Experience/>
      <Projects />
      <Contact />
    </>
  );
}
export default App;
